import React, { Fragment } from 'react'
import {
  Box,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  Table,
  Typography
} from '@mui/material'
import { Error as ErrorIcon } from '@mui/icons-material'
import { formatExpirationDate } from '../../../utils/dateHelper'

interface PickingRouteProductInfoProps {
  sku: string
  ean: string
  qty: number
  dunPacksQty: number | undefined
  dunUnitsQty: number | undefined
  name: string
  realQuantity?: string
  isRecall?: boolean
  batchNumber?: string
  expirationDate?: Date
}

export const PickingRouteProductInfo: React.FC<
  PickingRouteProductInfoProps
> = ({
  sku,
  ean,
  qty,
  name,
  dunPacksQty,
  dunUnitsQty,
  realQuantity,
  isRecall,
  batchNumber,
  expirationDate
}) => {
  return (
    <Fragment>
      <Box padding='5px' textAlign='center'>
        <Typography variant='caption' display='block' gutterBottom>
          {name}
        </Typography>
      </Box>

      <TableContainer component={Box}>
        <Table size='small' aria-label='a dense table'>
          <TableBody>
            <TableRow key='qty'>
              <TableCell component='th' scope='row'>
                Cant.
              </TableCell>
              <TableCell align='right'>
                <div>
                  <strong>
                    {`${qty}${
                      realQuantity !== undefined ? realQuantity : ''
                    } Un. `}
                  </strong>
                  {dunPacksQty! > 0 && ` (${dunPacksQty} Packs`}
                  {dunUnitsQty! <= 0 && dunPacksQty! > 0 && ')'}
                  {dunUnitsQty! > 0 &&
                    dunPacksQty! > 0 &&
                    ` + ${dunUnitsQty} Un.)`}
                </div>
              </TableCell>
            </TableRow>
            <TableRow key='sku'>
              <TableCell component='th' scope='row'>
                SKU
              </TableCell>
              <TableCell align='right'>{sku}</TableCell>
            </TableRow>
            <TableRow key='ean'>
              <TableCell component='th' scope='row'>
                EAN
              </TableCell>
              <TableCell align='right'>{ean}</TableCell>
            </TableRow>
            {expirationDate && (
              <TableRow key='expirationDate'>
                <TableCell
                  component='th'
                  scope='row'
                  style={{ fontWeight: 'bold' }}
                >
                  Fecha Expiración
                </TableCell>
                <TableCell align='right' style={{ fontWeight: 'bold' }}>
                  {formatExpirationDate(expirationDate, 'dd-MM-yyyy')}
                </TableCell>
              </TableRow>
            )}
            {batchNumber && (
              <TableRow key='batchNumber'>
                <TableCell
                  component='th'
                  scope='row'
                  style={{ fontWeight: 'bold' }}
                >
                  Lote
                </TableCell>
                <TableCell align='right' style={{ fontWeight: 'bold' }}>
                  {batchNumber}
                </TableCell>
              </TableRow>
            )}
            {isRecall && (
              <TableRow>
                <TableCell component='th' scope='row'></TableCell>
                <TableCell
                  style={{
                    color: 'red',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                  }}
                >
                  <ErrorIcon style={{ marginRight: '8px' }} />
                  {'Producto con orden de retiro activa'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  )
}
